import dynamic from "next/dynamic";
const NewsGrid1 = dynamic(() => import("@/component/NewsGrid/NewsGrid1"));
import SVG from "react-inlinesvg";
import AdSlot300x250 from "../Ads/AdSlot300x250";
import AdSlot728x90 from "../Ads/AdSlot728x90";
import { useContext, useState } from "react";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useRouter } from "next/router";

const SeriesCommonFooter = ({
  categoryNewsListData = null,
  faqData = null,
  isMobileDevice = false,
  showAds = false,
  scrolled = false,
  customHeading = null,
  showContent = false,
}) => {
  const masterConfig = useContext(MasterConfigContext);
  // const iplKeys = masterConfig["ipl_2025"];
  const router = useRouter();
  const currentPath = router?.asPath;
  const isTestSeries = currentPath.includes("/india-tour-of-england-2025");

  const [readMore, setReadMore] = useState(true);
  const content = `<p>भारतीय क्रिकेट टीम 5 मैचों की टेस्ट सीरीज खेलने के लिए  20 जून से 4 अगस्त 2025 तक इंग्लैंड के दौरे पर रहेगी. इस खास सीरीज को 'तेंदुलकर-एंडरसन ट्रॉफी' नाम दिया गया है, जो दो महान खिलाड़ियों, सचिन तेंदुलकर और जेम्स एंडरसन के सम्मान में है. भारतीय क्रिकेट टीम का इंग्लैंड दौरा हमेशा से टेस्ट क्रिकेट के सबसे कठिन और प्रतिष्ठित दौरों में गिना जाता है. तेज और स्विंग लेती पिच, लगातार बदलता मौसम और होम कंडीशंस में महारथी इंग्लिश टीम, ये सब मिलकर भारतीय खिलाड़ियों की कठिन परीक्षा लेते हैं. इस सीरीज के लिए भारत की कप्तानी शुभमन गिल को सौंपी गई है, जो अपने आक्रामक और संयमित नेतृत्व के लिए पहचाने जाते हैं. ऋषभ पंत को उप-कप्तान बनाया गया है, जो अपनी वापसी के बाद से शानदार फॉर्म में हैं. टीम के कोच होंगे गौतम गंभीर, जिनसे आक्रामक सोच और युवा खिलाड़ियों को आगे लाने की उम्मीद की जा रही है.</p>

  <p>इस सीरीज की खास बात ये है कि गिल-पंत की जोड़ी नए युग की अगुवाई कर रही है. इंग्लैंड के घरेलू मैदानों पर भारत की परफॉर्मेंस हमेशा चर्चा का विषय रहती है. कोच गंभीर की एग्रेसिव एप्रोच और युवाओं की मौजूदगी इस दौरे को बेहद खास बनाती है.</p>

  <p>पहला टेस्ट: 20–24 जून,  हेडिंग्ले, लीड्स<br>
  दूसरा टेस्ट: 2-6 जुलाई, एजबेस्टन, बर्मिंघम<br>
  तीसरा टेस्ट: 10-14 जुलाई, लॉर्ड्स, लंदन<br>
  चौथा टेस्ट: 23-27 जुलाई, ओल्ड ट्रैफर्ड, मैनचेस्टर<br>
  पांचवां टेस्ट: 31 जुलाई-4 अगस्त, द ओवल, लंदन</p>

  <p>टीम में युवा सितारे: यशस्वी जायसवाल, साई सुदर्शन, अभिमन्यु ईश्वरन<br>
  अनुभवी: केएल राहुल, रविंद्र जडेजा शामिल हैं.</p>`;

  let asia_cup_content = "";
  if (currentPath == ("/sports/asia-cup-2025")) {
    asia_cup_content = `क्रिकेट का महामुकाबला एशिया कप 2025 का 9 सितंबर से आगाज होगा और फाइनल मैच 28 सितंबर को दुबई इंटरनेशनल स्टेडियम में खेला जाएगा. यह एक टी-20 टूर्नामेंट है जिसमें कुल 8 टीमें हिस्सा लेंगी. पहले भारत को इसकी मेजबानी मिली थी, लेकिन बाद में इसका वेन्यू बदल कर UAE कर दिया गया है. इस टूर्नामेंट में 14 सितंबर को भारत-पाकिस्तान का मैच होगा. टी-20 एशिया कप के इतिहास में भारत ने अफगानिस्तान के खिलाफ 212/2 का सर्वोच्च स्कोर बनाया है. इस टूर्नामेंट में सर्वोच्च रन और सर्वोच्च विकेट का खिताब भारत के पास ही है. पिछले साल की बात करें तो श्रीलंका ने एशिया कप का खिताब अपने नाम कर लिया था. इसके मैचों का सीधा प्रसारण सोनी स्पोर्ट्स नेटवर्क पर और लाइव स्ट्रीमिंग सोनीलिव ऐप और वेबसाइट पर उपलब्ध होगी.`;
  } else if (currentPath?.includes("/sports/asia-cup-2025/stats")) {
    asia_cup_content = `इस साल एशिया कप का आगाज 9 सितंबर से होगा जिसमें की कुल 8 टीमें है. इन टीमों को दो ग्रुप में बांटा गया है. आंकड़ों की बात करें तो विराट कोहली ने इस फॉर्मेट में सबसे ज्यादा रन बनाया है. उन्होंने 10 मैचों में 429 रन बनाए है जिसमें की 4 अर्धशतक भी शामिल है. वहीं भुवनेश्वर कुमार ने 6 मैचों में 13 विकेट लेकर सबसे ज्यादा विकट लेने का खिताब अपने नाम किया है. भुवनेश्वर का सर्वश्रेष्ठ प्रदर्शन 4 रन देकर 5 विकेट लेने का है. साथ ही भारत ने अफगानिस्तान के खिलाफ 212/2 का सर्वाधिक स्कोर बनाया है, जो कि इस टूर्नामेंट का सबसे बड़ा स्कोर है. इस बार के आंकड़े आपको यहां मैचों के मुताबिक आप यहां देख सकते है.`
  } else if (currentPath?.includes("/sports/asia-cup-2025/points-table")) {
    asia_cup_content = `इन बार एशिया कप में कुल 8 टीमें हिस्सा ले रही है, जिन्हें दो ग्रुप A और B में बांटा गया है. इस टूर्नामेंट में सभी टीमों का मुख्य लक्ष्य अपने-अपने ग्रुप में टॉप 2 में जगह बनाना होगा, क्योंकि यही टीमें सुपर 4 के लिए क्वालीफाई करेंगी. हर मैच के बाद पॉइंट्स टेबल अपडेट होगी, जो टीमों की स्थिति को बताएगी कि कौन-सी किस जगह पर है. मौजूदा वक्त में टीमों की ग्रुप में स्थिति साफ नहीं है, लेकिन मैचों के परिणाम के आधार पर टीमें अपनी जगह बनाएंगी. सुपर 4 में बेहतर प्रदर्शन करने वाली दो टीमें 28 सितंबर को दुबई इंटरनेशनल स्टेडियम में होने वाले फाइनल मैच में भिड़ेंगी.`
  } else if (currentPath?.includes("/sports/asia-cup-2025/match-schedule-fixtures-and-results")) {
    asia_cup_content = `एशिया कप 2025 के कौन से मैच कहां होंगे, कहां होंगे, कौन सी टीम किसके साथ भिड़ेगी, मैच कितने बजे से होंगे, इन सब बातों की जानकारी आपको इस पेज पर मिलेगी. इसके साथ ही आपको क्वालीफायर से लेकर फाइनल मैचों की जानकारी भी यहीं मिलेगी. हर मैच के बाद पॉइंट्स टेबल अपडेट होगा जिसके आधार पर क्वालीफायर और आगे के मैच डिसाइड होंगे. इस टूर्नामेंट का सबसे आकर्षक मैच 14 सितंबर को भारत-पाकिस्तान का होने वाला है, जिस पर सबकी निगाहें होंगी.`
  }

  return (
    <div>
      {/* description  */}
      {showContent && (
        <>
          <h2 className="flex mt-12 mb-2 gap-2 items-start">
            <span className="bg-[#CC0000] w-2 h-4"></span>
            <span className="text-lg font-semibold -mt-1">
              {isTestSeries ? "India tour of England 2025" : "Asia Cup 2025"}
            </span>
          </h2>
          <p className={`text-[#323232] text-sm text-left relative inline`}>
            <p
              dangerouslySetInnerHTML={{
                __html: `${isTestSeries ? content : asia_cup_content}`,
              }}
              className={`${readMore ? "line-clamp-2" : ""} text-justify`}
            ></p>
            <span
              onClick={() => {
                setReadMore((prev) => !prev);
              }}
              className="cursor-pointer inline -ml-[0.5px]  text-primary text-sm"
            >
              {readMore ? "और देखें >" : "< कम देखें"}
            </span>
          </p>
        </>
      )}
      {/* faqs  */}

      {faqData && showContent && (
        <div className="my-4">
          <h2 className="text-lg font-semibold">
            {isTestSeries
              ? "India tour of England 2025 से जुड़े सवाल जवाब"
              : "एशिया कप 2025: अक्सर पूछे जाने वाले सवाल (FAQs)"}
          </h2>
          <section className="flex flex-col gap-4 text-gray-500 text-md font-extralight">
            <p
              className={`${isMobileDevice ? "custom-mb-break" : ""}`}
              dangerouslySetInnerHTML={{
                __html: `${faqData?.content?.description_short}`,
              }}
            />
          </section>
        </div>
      )}
      {categoryNewsListData && categoryNewsListData?.content?.length > 0 && (
        <section className="my-4">
          <div className="flex items-center justify-between mt-8">
            <h2 className="text-lg font-semibold">
              {customHeading ? customHeading : "IPL न्यूज"}
            </h2>
            <a href="/sports">
              <span className="flex items-center text-sm">
                और देखें
                <SVG
                  className="w-6 h-6 inline ml-2  mt-[-2px]"
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/rightArrowRound.svg"
                />
              </span>
            </a>
          </div>
          <div className="text-16">
            <NewsGrid1
              newsData={categoryNewsListData || null}
              showLiveVideo={false}
              showAd={false}
              isLCP={false}
              isMobileDevice={isMobileDevice}
              liveVideoData={null}
              isResultsPage={true}
            />
          </div>
        </section>
      )}

      {showAds && scrolled && (
        <AdSlot300x250
          divId="div-gpt-ad-1659434785315-0"
          minWidth="300px"
          minHeight="250px"
        />
      )}

      {showAds && scrolled && (
        <AdSlot728x90
          divId="div-gpt-ad-1707804176041-3"
          minWidth="720px"
          minHeight="90px"
        />
      )}
    </div>
  );
};

export default SeriesCommonFooter;
